import { render, staticRenderFns } from "./canteenAdmin.vue?vue&type=template&id=1459af2e&scoped=true&"
import script from "./canteenAdmin.vue?vue&type=script&lang=js&"
export * from "./canteenAdmin.vue?vue&type=script&lang=js&"
import style0 from "./canteenAdmin.vue?vue&type=style&index=0&id=1459af2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1459af2e",
  null
  
)

export default component.exports